/**
 * NURVENA ORGANICS — Main Theme Script
 * Premium UX Interactions & eCommerce Event Hooks
 */

document.addEventListener('DOMContentLoaded', function () {
  initHeader();
  initMobileMenu();
  initSearch();
  initCartDrawer();
  initBeforeAfterSlider();
  initProductGallery();
  initScrollAnimations();
  initStickyAddToCart();
  initHeroSmoothScroll();
  initAjaxAddToCartButtons();
});

/**
 * 1. Sticky Transparent Header Scroll Toggle
 */
function initHeader() {
  const header = document.getElementById('js-header');
  if (!header) return;

  function checkScroll() {
    if (window.scrollY > 20) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }

  window.addEventListener('scroll', checkScroll);
  checkScroll(); // Run initially
}

/**
 * 2. Mobile Menu Drawer Animation
 */
function initMobileMenu() {
  const hamburger = document.getElementById('js-hamburger');
  const mobileMenu = document.getElementById('js-mobile-menu');
  const overlay = document.getElementById('js-overlay');

  if (!hamburger || !mobileMenu || !overlay) return;

  function toggleMenu() {
    const isOpen = mobileMenu.classList.contains('is-open');
    if (isOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  function openMenu() {
    hamburger.classList.add('is-active');
    hamburger.setAttribute('aria-expanded', 'true');
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    hamburger.classList.remove('is-active');
    hamburger.setAttribute('aria-expanded', 'false');
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  hamburger.addEventListener('click', toggleMenu);
  overlay.addEventListener('click', closeMenu);
}

/**
 * 3. Search Field Overlay Zoom
 */
function initSearch() {
  const searchToggle = document.getElementById('js-search-toggle');
  const searchClose = document.getElementById('js-search-close');
  const searchOverlay = document.getElementById('js-search-overlay');
  const searchInput = searchOverlay ? searchOverlay.querySelector('input[type="search"]') : null;

  if (!searchToggle || !searchOverlay) return;

  searchToggle.addEventListener('click', function () {
    searchOverlay.classList.add('is-open');
    searchOverlay.setAttribute('aria-hidden', 'false');
    if (searchInput) {
      setTimeout(() => searchInput.focus(), 300);
    }
  });

  function closeSearch() {
    searchOverlay.classList.remove('is-open');
    searchOverlay.setAttribute('aria-hidden', 'true');
  }

  if (searchClose) searchClose.addEventListener('click', closeSearch);
  
  // Close on Escape key press
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && searchOverlay.classList.contains('is-open')) {
      closeSearch();
    }
  });
}

/**
 * 4. AJAX Cart Drawer Operations & Shipping Goal Updates
 */
function initCartDrawer() {
  const cartToggle = document.getElementById('js-cart-toggle');
  const cartDrawerClose = document.getElementById('js-cart-drawer-close');
  const cartDrawer = document.getElementById('js-cart-drawer');
  const overlay = document.getElementById('js-overlay');
  const cartShop = document.getElementById('js-cart-drawer-shop');

  if (!cartDrawer) return;

  function openDrawer() {
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    // Only remove active overlay if mobile menu isn't also open
    const hamburger = document.getElementById('js-hamburger');
    if (!hamburger || !hamburger.classList.contains('is-active')) {
      overlay.classList.remove('is-active');
      document.body.style.overflow = '';
    }
  }

  if (cartToggle) cartToggle.addEventListener('click', openDrawer);
  if (cartDrawerClose) cartDrawerClose.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (cartShop) cartShop.addEventListener('click', closeDrawer);

  // Dynamic AJAX Add-to-Cart hook
  const productForm = document.getElementById('js-product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(productForm);

      fetch(window.NurvenaOrganics.routes.cart_add_url, {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/javascript' }
      })
      .then(response => response.json())
      .then(() => {
        // Refresh cart drawer layout and open it
        refreshCart();
        openDrawer();
      })
      .catch(error => console.error('Error adding to cart:', error));
    });
  }

  // Bind clicks on quantities and removals
  cartDrawer.addEventListener('click', function (e) {
    if (e.target.classList.contains('js-qty-btn')) {
      const btn = e.target;
      const key = btn.dataset.key;
      const action = btn.dataset.action;
      const valSpan = btn.parentElement.querySelector('.js-qty-val');
      let currentVal = parseInt(valSpan.textContent);

      if (action === 'plus') {
        updateCartItemQuantity(key, currentVal + 1);
      } else if (action === 'minus' && currentVal > 1) {
        updateCartItemQuantity(key, currentVal - 1);
      }
    }

    if (e.target.classList.contains('js-cart-remove')) {
      const key = e.target.dataset.key;
      updateCartItemQuantity(key, 0);
    }
  });

  // AJAX quantity updater
  function updateCartItemQuantity(key, qty) {
    const data = { id: key, quantity: qty };

    fetch(window.NurvenaOrganics.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(cartJson => {
      renderCartDrawerHtml(cartJson);
    })
    .catch(error => console.error('Error updating quantity:', error));
  }

  // AJAX Fetch full cart details
  function refreshCart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cartJson => {
        renderCartDrawerHtml(cartJson);
      });
  }

  // HTML renderer for the Cart drawer items loop
  function renderCartDrawerHtml(cart) {
    // Update header count badge
    const badge = document.getElementById('js-cart-count');
    if (badge) badge.textContent = cart.item_count;

    const itemsContainer = document.getElementById('js-cart-items-container');
    const footerContainer = cartDrawer.querySelector('.cart-drawer-footer');
    if (!itemsContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.innerHTML = `
        <div class="cart-empty">
          <p>Your basket is currently empty.</p>
          <button type="button" class="btn btn-primary btn-sm" id="js-cart-drawer-shop-empty">Shop Our Oils</button>
        </div>
      `;
      const emptyShopBtn = document.getElementById('js-cart-drawer-shop-empty');
      if (emptyShopBtn) emptyShopBtn.addEventListener('click', closeDrawer);
      if (footerContainer) footerContainer.remove();
      return;
    }

    // Generate Item loops markup
    let itemsHtml = '';
    cart.items.forEach(item => {
      const imgMarkup = item.image 
        ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">`
        : `<div class="placeholder-img"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><rect x="3" y="3" width="18" height="18" rx="2"/></svg></div>`;

      const variantTitle = item.variant_options && item.variant_title
        ? `<p style="font-size: 0.8rem; color: var(--color-text-light); margin-bottom: 6px;">${item.variant_title}</p>`
        : '';

      const finalPrice = formatMoney(item.line_price);

      itemsHtml += `
        <div class="cart-item" data-key="${item.key}">
          <div class="cart-item-image">
            ${imgMarkup}
          </div>
          <div class="cart-item-details">
            <h4 class="cart-item-title">${item.product_title}</h4>
            ${variantTitle}
            <p class="cart-item-price">${finalPrice}</p>
            <div style="display: flex; align-items: center; justify-content: space-between;">
              <div class="cart-qty">
                <button type="button" class="js-qty-btn" data-action="minus" data-key="${item.key}">−</button>
                <span class="js-qty-val">${item.quantity}</span>
                <button type="button" class="js-qty-btn" data-action="plus" data-key="${item.key}">+</button>
              </div>
              <button type="button" class="js-cart-remove" data-key="${item.key}" style="font-size: 0.8rem; color: var(--color-text-light); text-decoration: underline;">
                Remove
              </button>
            </div>
          </div>
        </div>
      `;
    });

    itemsContainer.innerHTML = itemsHtml;

    // Render / Update Footer Checkout Panel
    const totalAmountStr = formatMoney(cart.total_price);
    if (footerContainer) {
      const subtotal = document.getElementById('js-cart-subtotal');
      if (subtotal) subtotal.textContent = totalAmountStr;
    } else {
      const footerMarkup = document.createElement('div');
      footerMarkup.className = 'cart-drawer-footer';
      footerMarkup.innerHTML = `
        <div class="cart-subtotal">
          <span>Subtotal</span>
          <strong id="js-cart-subtotal">${totalAmountStr}</strong>
        </div>
        <p style="font-size: 0.8rem; color: var(--color-text-light); margin-bottom: 16px; text-align: center;">
          Taxes and shipping calculated at checkout.
        </p>
        <form action="/cart" method="post">
          <button type="submit" name="checkout" class="btn btn-primary">Proceed to Checkout</button>
        </form>
      `;
      cartDrawer.appendChild(footerMarkup);
    }
  }

  // Shopify simple currency formatter helper
  function formatMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    // Simple mock using shop format or generic USD fallback
    const format = window.NurvenaOrganics.money_format || '$${amount}';
    return format.replace('${amount}', dollars).replace('{{amount}}', dollars);
  }
}

/**
 * 5. Interactive Before & After comparison slider logic (Mouse + Touch)
 */
function initBeforeAfterSlider() {
  const container = document.getElementById('js-before-after');
  const slider = document.getElementById('js-ba-slider');
  const afterImg = document.getElementById('js-ba-after');

  if (!container || !slider || !afterImg) return;

  let active = false;

  function slide(x) {
    let rect = container.getBoundingClientRect();
    let position = ((x - rect.left) / rect.width) * 100;
    
    // Bounds check
    if (position < 0) position = 0;
    if (position > 100) position = 100;

    slider.style.left = position + '%';
    afterImg.style.clipPath = `inset(0 ${100 - position}% 0 0)`;
  }

  // Mouse controls
  container.addEventListener('mousedown', function (e) {
    active = true;
    slide(e.pageX);
  });
  window.addEventListener('mouseup', function () {
    active = false;
  });
  window.addEventListener('mousemove', function (e) {
    if (!active) return;
    slide(e.pageX);
  });

  // Touch controls (Mobile responsiveness)
  container.addEventListener('touchstart', function (e) {
    active = true;
    slide(e.touches[0].clientX);
  });
  window.addEventListener('touchend', function () {
    active = false;
  });
  window.addEventListener('touchmove', function (e) {
    if (!active) return;
    slide(e.touches[0].clientX);
  });
}

/**
 * 6. Product Page Gallery: Thumbnail switcher & Magnifier zoom
 */
function initProductGallery() {
  const mainImage = document.getElementById('js-product-main-image');
  const mainImgWrap = document.getElementById('js-main-img-wrap');
  const thumbs = document.querySelectorAll('.js-product-thumb');

  if (!mainImage || !thumbs.length) return;

  // Thumbnail switching logic
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function () {
      thumbs.forEach(t => t.classList.remove('is-active'));
      this.classList.add('is-active');

      const newSrc = this.dataset.src;
      if (newSrc) {
        mainImage.style.opacity = '0';
        setTimeout(() => {
          mainImage.src = newSrc;
          mainImage.style.opacity = '1';
        }, 150);
      }
    });
  });

  // Modern Hover Zoom Effect (Skincare brands feel)
  if (mainImgWrap) {
    mainImgWrap.addEventListener('mousemove', function (e) {
      const rect = mainImgWrap.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      mainImage.style.transformOrigin = `${x}% ${y}%`;
      mainImage.style.transform = 'scale(1.5)';
    });

    mainImgWrap.addEventListener('mouseleave', function () {
      mainImage.style.transform = 'scale(1)';
      mainImage.style.transformOrigin = 'center center';
    });
  }
}

/**
 * 7. Modern Intersection Observer Scroll Animations
 */
function initScrollAnimations() {
  const anims = document.querySelectorAll('[data-animate]');
  const staggers = document.querySelectorAll('[data-stagger]');

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.12
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target); // Trigger animation once
      }
    });
  }, observerOptions);

  anims.forEach(anim => observer.observe(anim));
  staggers.forEach(stagger => observer.observe(stagger));
}

/**
 * 8. Product Page: Sticky Add-to-cart Scroll-triggered Reveal bar
 */
function initStickyAddToCart() {
  const stickyBar = document.getElementById('js-sticky-bar');
  const buyBtn = document.querySelector('.product-form .btn');

  if (!stickyBar || !buyBtn) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      // Show sticky bar once actual form CTA scrolled past viewport
      if (!entry.isIntersecting) {
        stickyBar.style.transform = 'translateY(0)';
      } else {
        stickyBar.style.transform = 'translateY(100%)';
      }
    });
  }, { threshold: 0 });

  observer.observe(buyBtn);
}

/**
 * 9. Hero "Shop Now" Smooth Scroll to Products Section
 */
function initHeroSmoothScroll() {
  const heroBtn = document.getElementById('hero-shop-now');
  if (!heroBtn) return;

  heroBtn.addEventListener('click', function (e) {
    e.preventDefault();
    const target = document.getElementById('featured-products');
    if (!target) {
      // Fallback: navigate to collections if section not found
      window.location.href = '/collections/all';
      return;
    }

    const headerHeight = document.getElementById('js-header')
      ? document.getElementById('js-header').offsetHeight
      : 0;

    const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 20;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  });
}

/**
 * 10. AJAX Add-to-Cart for Product Cards (smooth checkout flow)
 *     Intercepts all product card forms and adds items via AJAX,
 *     then opens the cart drawer — no page reload needed.
 */
function initAjaxAddToCartButtons() {
  const cartDrawer = document.getElementById('js-cart-drawer');
  const overlay = document.getElementById('js-overlay');
  if (!cartDrawer) return;

  document.addEventListener('submit', function (e) {
    const form = e.target;
    // Only intercept add-to-cart forms (action="/cart/add")
    if (!form.matches('form[action="/cart/add"]')) return;
    // Skip the main product form (already handled in initCartDrawer)
    if (form.id === 'js-product-form') return;

    // Skip if the user clicked "Quick Buy" (which goes directly to checkout)
    if (e.submitter && e.submitter.name === 'return_to') return;

    e.preventDefault();

    const submitBtn = form.querySelector('button[type="submit"]');
    const originalText = submitBtn ? submitBtn.textContent : '';

    // Visual feedback
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';
      submitBtn.style.opacity = '0.7';
    }

    const formData = new FormData(form);

    fetch(window.NurvenaOrganics ? window.NurvenaOrganics.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/javascript' }
    })
    .then(response => response.json())
    .then(() => {
      // Refresh cart contents
      return fetch('/cart.js').then(r => r.json());
    })
    .then(cartJson => {
      // Update cart count badge
      const badge = document.getElementById('js-cart-count');
      if (badge) badge.textContent = cartJson.item_count;

      // Restore button with success state
      if (submitBtn) {
        submitBtn.textContent = '✓ Added!';
        submitBtn.style.opacity = '1';
        submitBtn.style.background = 'var(--color-primary-dark)';

        setTimeout(() => {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
          submitBtn.style.background = '';
        }, 1500);
      }

      // Open cart drawer
      cartDrawer.classList.add('is-open');
      cartDrawer.setAttribute('aria-hidden', 'false');
      if (overlay) {
        overlay.classList.add('is-active');
      }
      document.body.style.overflow = 'hidden';

      // Re-render cart drawer items
      renderCartDrawerFromJson(cartJson);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      if (submitBtn) {
        submitBtn.textContent = originalText;
        submitBtn.disabled = false;
        submitBtn.style.opacity = '1';
      }
    });
  });

  /**
   * Lightweight cart drawer renderer for AJAX updates from product cards
   */
  function renderCartDrawerFromJson(cart) {
    const itemsContainer = document.getElementById('js-cart-items-container');
    if (!itemsContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.innerHTML = `
        <div class="cart-empty">
          <p>Your basket is currently empty.</p>
          <button type="button" class="btn btn-primary btn-sm" onclick="document.getElementById('js-cart-drawer').classList.remove('is-open');document.getElementById('js-overlay').classList.remove('is-active');document.body.style.overflow='';">Shop Our Oils</button>
        </div>
      `;
      return;
    }

    let itemsHtml = '';
    cart.items.forEach(item => {
      const imgMarkup = item.image
        ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy">`
        : `<div class="placeholder-img"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><rect x="3" y="3" width="18" height="18" rx="2"/></svg></div>`;

      const variantTitle = item.variant_title && item.variant_title !== 'Default Title'
        ? `<p style="font-size: 0.8rem; color: var(--color-text-light); margin-bottom: 6px;">${item.variant_title}</p>`
        : '';

      const price = formatCartMoney(item.final_line_price);

      itemsHtml += `
        <div class="cart-item" data-key="${item.key}" style="animation:cartItemSlideIn .4s ease forwards">
          <div class="cart-item-image">${imgMarkup}</div>
          <div class="cart-item-details">
            <h4 class="cart-item-title">${item.product_title}</h4>
            ${variantTitle}
            <p class="cart-item-price">${price}</p>
            <div style="display:flex;align-items:center;justify-content:space-between;">
              <div class="cart-qty">
                <button type="button" class="js-qty-btn" data-action="minus" data-key="${item.key}">−</button>
                <span class="js-qty-val">${item.quantity}</span>
                <button type="button" class="js-qty-btn" data-action="plus" data-key="${item.key}">+</button>
              </div>
              <button type="button" class="js-cart-remove" data-key="${item.key}" style="font-size:0.8rem;color:var(--color-text-light);text-decoration:underline;">Remove</button>
            </div>
          </div>
        </div>
      `;
    });

    itemsContainer.innerHTML = itemsHtml;

    // Update or create footer
    const totalStr = formatCartMoney(cart.total_price);
    let footer = cartDrawer.querySelector('.cart-drawer-footer');
    if (footer) {
      const subtotal = document.getElementById('js-cart-subtotal');
      if (subtotal) subtotal.textContent = totalStr;
    } else {
      footer = document.createElement('div');
      footer.className = 'cart-drawer-footer';
      footer.innerHTML = `
        <div class="cart-subtotal">
          <span>Subtotal</span>
          <strong id="js-cart-subtotal">${totalStr}</strong>
        </div>
        <p style="font-size:0.8rem;color:var(--color-text-light);margin-bottom:16px;text-align:center;">
          Taxes and shipping calculated at checkout.
        </p>
        <form action="/cart" method="post">
          <button type="submit" name="checkout" class="btn btn-primary">Proceed to Checkout</button>
        </form>
      `;
      cartDrawer.appendChild(footer);
    }
  }

  function formatCartMoney(cents) {
    const dollars = (cents / 100).toFixed(2);
    const format = (window.NurvenaOrganics && window.NurvenaOrganics.money_format) || '$${amount}';
    return format.replace('${amount}', dollars).replace('{{amount}}', dollars);
  }
}
